import TabPane from "./tab-pane.js";
import TabsElement from "./tabs.js";
const Tabs = TabsElement;
Tabs.TabPane = TabPane;
export default Tabs;
